import layouts from 'scripts/util/layouts'

class Anchor {
  constructor(elementOrSelector) {
    this.$root = $(elementOrSelector);
    this.$root.on('click', this.onClick.bind(this));
    this.id = this.$root.attr('href').substring(this.$root.attr('href').indexOf('#') + 1);
  }
  onClick (event) {
    event.preventDefault();
    this.scroll();
  }
  destroy() {
    this.off('click', this.onClick.bind(this));
  }
  scroll() {
    if (this.id === '') {
      return;
    }
    const $target = $(`#${this.id}`);
    if ($target.length <= 0) {
      return;
    }
    $.Velocity($target, 'scroll', {
      duration: 300,
      easing: "easeInOutQuad",
      offset: layouts.getHeaderOffset()
    });
  }
}

(() => {
  $.fn.fvAnchor = function plugin() {
    const func = {
      execute: ($target) => {
        $target.$anchor = new Anchor($target);
        $target.destroy = $target.$anchor.destroy;
      },
    };
    return this.each(function cb() {
      const $target = $(this);
      func.execute($target);
    });
  };
})();


// WEBPACK FOOTER //
// ./scripts/autoload/jquery-plugins/Anchor.js